import * as React from "react";

const ProfileIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" {...props}>
		<path
			style={{
				fill: "none",
			}}
			d="M-5-4.72h66v66H-5z"
		/>
		<path d="M28 42.03c10.07 0 18.88 4.33 23.67 10.79l-5.07 2.4c-3.9-4.62-10.77-7.69-18.6-7.69S13.3 50.6 9.4 55.22l-5.06-2.4c4.79-6.46 13.6-10.79 23.67-10.79ZM28 .78c3.65 0 7.14 1.45 9.72 4.03 2.58 2.58 4.03 6.08 4.03 9.72v8.25c0 3.65-1.45 7.14-4.03 9.72-2.58 2.58-6.08 4.03-9.72 4.03s-7.14-1.45-9.72-4.03a13.755 13.755 0 0 1-4.03-9.72v-8.25c0-3.65 1.45-7.14 4.03-9.72S24.35.78 28 .78Z" />
	</svg>
);

export default ProfileIcon;
